import { render, staticRenderFns } from "./CardDetailsInviteProcessor.vue?vue&type=template&id=27f726c8"
import script from "./CardDetailsInviteProcessor.vue?vue&type=script&lang=js"
export * from "./CardDetailsInviteProcessor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports